import { render, staticRenderFns } from "./SidebarHelpCenter.vue?vue&type=template&id=0115c833&scoped=true&"
import script from "./SidebarHelpCenter.vue?vue&type=script&lang=js&"
export * from "./SidebarHelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./SidebarHelpCenter.vue?vue&type=style&index=0&id=0115c833&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115c833",
  null
  
)

export default component.exports